/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_DateInputs */



/**
* | output |
* | --- |
* | "Date" |
*
* @param {Invoice_DateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const invoice_date = /** @type {((inputs?: Invoice_DateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_DateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Date")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datum")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дата")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("日期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("日付")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तारीख")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Data")
	return /** @type {LocalizedString} */ ("Date")
});